import { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { DropdownMobileMenu } from '../../components/DropdownMobileMenu/DropdownMobileMenu';
import { PrimaryMenuItemCommonTypes, PrimaryMenuItemMobile } from '../../components/PrimaryMenu';
import { UserAvatar } from '../../components/UserAvatar/UserAvatar';
import { useUserData } from '../../context';
import { messages } from '../../i18n';
import { UserDropdownMenuItems } from './UserDropdownMenuItems';

export const UserDropdownMenuTriggerMobile = forwardRef<HTMLButtonElement, PrimaryMenuItemCommonTypes>((props, ref) => {
  const { userData: user } = useUserData();

  return (
    <PrimaryMenuItemMobile ref={ref} data-test-specifier="user-avatar-menu" analyticsMessage="user menu mobile" {...props}>
      <UserAvatar userInfo={user?.userInfo} />
    </PrimaryMenuItemMobile>
  );
});

export const UserDropdownMenuMobile = () => {
  const { formatMessage } = useIntl();

  return (
    <DropdownMobileMenu headerTitle={formatMessage(messages.userMobileMenuHeader)} trigger={<UserDropdownMenuTriggerMobile />}>
      <UserDropdownMenuItems isMobile={true} />
    </DropdownMobileMenu>
  );
};
